var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumPrimaryMedical = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50V50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    fillRule: "nonzero",
    d: "M42.124 16.438h-8.562V7.843C33.562 6.26 32.302 5 30.72 5H19.28c-1.583 0-2.843 1.26-2.843 2.843v8.595H7.843C6.26 16.438 5 17.698 5 19.28V30.72c0 1.583 1.26 2.843 2.843 2.843h8.595v8.595c0 1.583 1.26 2.843 2.843 2.843H30.72c.388 0 .775-.065 1.098-.226.84-.356 1.487-1.131 1.68-2.036.033-.194.065-.387.065-.581v-8.595h8.595c1.583 0 2.843-1.26 2.843-2.843V19.28c0-1.583-1.292-2.843-2.876-2.843z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumPrimaryMedical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-primary-medical.4b8f1197d7f6b12a80bf46be6c2a5e9c.svg";